import { Component, HostBinding, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ca-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    standalone: false
})
export class AboutComponent implements OnInit {
  @HostBinding('style.width')
  componentWidth = '100%';

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {}

  openVersionModal(content) {
    const modalRef = this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      size: 'md',
      windowClass: 'ca-about-version-modal',
    });

    // NgbModal auto-focuses the first focusable element (the logo link) on open,
    // which paints a visible focus ring around the logo. Move focus to the
    // Close button instead once the modal's entrance transition has finished.
    modalRef.shown.subscribe(() => {
      const closeButton = document.querySelector<HTMLElement>(
        '.ca-about-version-modal .btn-outline-dark'
      );
      closeButton?.focus();
    });
  }
}
